<template>
    <div>
        <vs-alert style="max-width: 300px;" :active="projectHours > 0" class="mt-2 mb-3" :color="(projectHours >= projectHoursUsed) ? 'success' : 'danger'" icon="access_time"> {{$t("ProjectHours")}} {{projectHoursUsed}}/{{projectHours}}</vs-alert>

        <vs-table ref="table" :data="taskTimes">

            <template slot="header">
            </template>

            <template slot="thead">
                <vs-th sort-key="user">{{$t("User")}}</vs-th>
                <vs-th sort-key="total_time">{{$t("TotalTime")}}</vs-th>
                <vs-th sort-key="start_time">{{$t("StartTime")}}</vs-th>
                <vs-th sort-key="end_time">{{$t("EndTime")}}</vs-th>
                <vs-th sort-key="work_type">{{$t("WorkType")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr v-if="data[index].sub_times.length > 0" :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].user_id">
                            {{ users[data[index].user_id].name }}
                        </vs-td>

                        <vs-td :data="data[index].total_time">
                            {{ data[index].total_time }}
                        </vs-td>

                        <vs-td :data="data[index].sub_times[0].start_time">
                            {{ moment(data[index].sub_times[0].start_time).format('DD/MM/YYYY HH:mm') }}
                        </vs-td>

                        <vs-td :data="data[index].sub_times[data[index].sub_times.length - 1].end_time">
                            {{ moment(data[index].sub_times[data[index].sub_times.length - 1].end_time).format('DD/MM/YYYY HH:mm') }}
                        </vs-td>

                        <vs-td :data="data[index].work_type" v-if="workTypeMap[data[index].work_type_id]">
                            {{ workTypeMap[data[index].work_type_id].name }}
                        </vs-td>

                        <template slot="expand">
                            <vs-row vs-w="12">
                                <vs-col vs-w="6" vs-sm="12" class="mt-6">
                                    <!--<div style="width: 60%; float: left">
                                        <div>
                                            <h5 style="float:left;" class="mt-3">{{$t("Notes")}}</h5>
                                            <vs-button style="float:left;" color="success" icon-pack="feather" icon="icon-edit" type="border" class="ml-2" @click="openNotesEditPrompt(data[index].id, data[index].notes)" size="small"></vs-button>

                                        </div>
                                        <div style="clear: left"></div>

                                    </div>
                                    <div style="width: 40%; float: left">
                                        Test
                                    </div>-->
                                    <div class="mb-base" id="page-user-view" v-if="workTypeMap[data[index].work_type_id]">
                                        <div  style="display: flex" v-if="$store.getters.userData.id === tr.user_id || $checkPermission(107)">
                                            <vx-tooltip :text="$t('EditNotes')">
                                                <vs-button style="float: left" class="mr-2" color="dark" icon-pack="feather" icon="icon-file-text" type="border" @click="openNotesEditPrompt(data[index].id, data[index].notes)" size="small"></vs-button>
                                            </vx-tooltip>
                                            <vx-tooltip :text="$t('EditWorkType')">
                                                <vs-button style="float: left" class="mr-2" color="dark" icon-pack="feather" icon="icon-briefcase" type="border" @click="openEditWorkTypePrompt(data[index].id, data[index].work_type_id)" size="small"></vs-button>
                                            </vx-tooltip>
                                            <vx-tooltip :text="$t('EditInvoicing')">
                                                <vs-button style="float: left" class="mr-2" color="dark" icon="receipt" type="border" @click="openInvoicingEditPrompt(data[index].id, data[index].non_invoiced_part, data[index].non_invoiced_time, data[index].non_invoiced_comment, data[index].total_time)" size="small"></vs-button>
                                            </vx-tooltip>
                                        </div>

                                        <vs-divider></vs-divider>

                                        <table>
                                            <tr>
                                                <td class="font-semibold">{{$t("WorkType")}}</td>
                                                <td>{{ workTypeMap[data[index].work_type_id].name }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-semibold">{{$t("NonInvoicedPart")}}</td>
                                                <td v-if="data[index].non_invoiced_part">{{$t("Yes")}}</td>
                                                <td v-else>{{$t("No")}}</td>
                                            </tr>
                                            <tr v-if="data[index].non_invoiced_part">
                                                <td class="font-semibold">{{$t("NonInvoicedTime")}}</td>
                                                <td>{{data[index].non_invoiced_time}}</td>
                                            </tr>
                                            <tr v-if="data[index].non_invoiced_part">
                                                <td class="font-semibold">{{$t("InvoicingComment")}}</td>
                                                <td style="white-space: pre-wrap">{{data[index].non_invoiced_comment}}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-semibold">{{$t("Notes")}}</td>
                                            </tr>
                                        </table>
                                        <p style="white-space: pre-wrap">{{data[index].notes}}</p>

                                    </div>
                                </vs-col>
                                <vs-col vs-w="6" vs-sm="12" class="mt-6">
                                    <vs-table :data="data[index].sub_times">

                                        <template slot="thead">
                                            <vs-th sort-key="start_time">{{$t("StartTime")}}</vs-th>
                                            <vs-th sort-key="end_time">{{$t("EndTime")}}</vs-th>
                                            <vs-th v-if="$store.getters.userData.id === tr.user_id || $checkPermission(107)"></vs-th>
                                        </template>

                                        <template slot-scope="{data}">
                                            <vs-tr :data="tr1" :key="index1" v-for="(tr1, index1) in data">

                                                <vs-td :data="data[index1].start_time">
                                                    {{ moment(data[index1].start_time).format('DD/MM/YYYY HH:mm') }}
                                                </vs-td>

                                                <vs-td :data="data[index1].end_time">
                                                    {{ moment(data[index1].end_time).format('DD/MM/YYYY HH:mm') }}
                                                </vs-td>

                                                <vs-td v-if="$store.getters.userData.id === tr.user_id || $checkPermission(107)">
                                                    <div style="display: flex">
                                                        <vx-tooltip v-if="$checkPermission(107)" :text="$t('EditTime')">
                                                            <vs-button style="float: left" color="dark" icon-pack="feather" icon="icon-edit" type="border" class="ml-2" @click="openTimeEditPrompt(data[index1].id, data[index1].start_time, data[index1].end_time)" size="small"></vs-button>
                                                        </vx-tooltip>
                                                        <vx-tooltip :text="$t('RemoveTime')">
                                                            <vs-button style="float: left" color="dark" icon-pack="feather" icon="icon-x" type="border" class="ml-2" @click="openTimeRemovePrompt(data[index1].id)" size="small"></vs-button>
                                                        </vx-tooltip>
                                                        <vx-tooltip :text="$t('Multiplier')">
                                                            <vs-button style="float: left" color="dark" icon="iso" type="border" class="ml-2" @click="openMultiplierPrompt(data[index1].id, data[index1].multiplier)" size="small"></vs-button>
                                                        </vx-tooltip>
                                                    </div>
                                                </vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>
                                </vs-col>
                            </vs-row>
                        </template>
                    </vs-tr>
                </tbody>
            </template>

        </vs-table>
        <!--<div v-if="selected.id" class="p-3">
            <div v-if="this.$store.getters.userData.id === selected.user_id">
                <vs-divider></vs-divider>
                <h5 class="mb-4">{{$t("EditTime")}}</h5>
                <vs-row vs-w="12">
                    <vs-col vs-w="9" vs-sm="12">
                        <vs-row vs-w="12" vs-justify="space-around">
                            <vs-col vs-w="3" vs-sm="12">
                                <p>{{$t("StartTime")}}</p>
                                <flat-pickr :config="configDateTimePicker" v-model="startTimeEdit"></flat-pickr>
                            </vs-col>
                            <vs-col vs-w="3" vs-sm="12">
                                <p>{{$t("EndTime")}}</p>
                                <flat-pickr :config="configDateTimePicker" v-model="endTimeEdit"></flat-pickr>
                            </vs-col>
                            <vs-col vs-w="3" vs-sm="12">
                                <p>{{$t("WorkType")}}</p>
                                <vs-select autocomplete class="selectExample" v-model="selectedWorkType">
                                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in workTypes" />
                                </vs-select>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-w="3" vs-sm="12" class="mt-3">
                        <vs-button style="float:left;" color="success" type="border" class="mb-6 mr-6" @click="editTime">{{$t("Change")}}</vs-button>
                        <vs-button style="float:left;"  color="danger" type="border" @click="removeTime">{{$t("Delete")}}</vs-button>
                    </vs-col>
                </vs-row>
            </div>

        </div>-->


        <vs-popup :title="$t('Edit')" :active.sync="activeNotesPrompt" style="z-index: 54000">
            <div>
                <span>{{$t("Notes")}}</span>
                <vs-textarea v-model="notesEditArea" class="mt-3 w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="saveNotes">{{$t("Save")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Add')" :active.sync="activeNewTimePrompt" style="z-index: 54000">
            <div>
                <p class="mt-6">{{$t("WorkType")}}</p>
                <vs-select autocomplete class="selectExample" v-model="selectedWorkTypeAdd">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in workTypes" />
                </vs-select>
                <p class="mt-6">{{$t("Notes")}}</p>
                <vs-textarea v-model="notesEditAreaAdd" class="w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addTime">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editSubTimePrompt" style="z-index: 54000">
            <div>
                <p>{{$t("StartTime")}}</p>
                <flat-pickr @on-open="changeEditTimeStartOpenStatus(true)" @on-close="changeEditTimeStartOpenStatus(false)" :config="configDateTimePicker" v-model="subTimeEdit['start_time']"></flat-pickr>
                <p>{{$t("EndTime")}}</p>
                <flat-pickr @on-open="changeEditTimeEndOpenStatus(true)" @on-close="changeEditTimeEndOpenStatus(false)" :config="configDateTimePicker" v-model="subTimeEdit['end_time']"></flat-pickr>
                <p class="mt-6">{{$t("Reason")}}</p>
                <vs-textarea v-model="subTimeEdit['reason']" class="w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="editSubTime">{{$t("Save")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup @accept="removeTime" style="z-index: 54000" :title="$t('RemoveTime')" :active.sync="activeRemoveTimePrompt">
            <p class="mt-6">{{$t("Reason")}}</p>
            <vs-textarea v-model="removeTimeReason" class="w-full" />
            <vs-divider/>
            <vs-button color="success" type="border" class="mt-6; mr-1" @click="removeTime">{{$t("Save")}}</vs-button>
        </vs-popup>

        <vs-popup style="z-index: 54000" :title="$t('Edit')" :active.sync="activeMultiplierPrompt">
            <p class="mt-6">{{$t("Multiplier")}}</p>
            <vs-select autocomplete class="selectExample" v-model="multiplier">
                <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in $store.state.multipliers" />
            </vs-select>
            <p class="mt-6">{{$t("Reason")}}</p>
            <vs-textarea v-model="multiplierEditReason" class="w-full" />
            <vs-divider/>
            <vs-button color="success" type="border" class="mt-6; mr-1" @click="editMultiplier">{{$t("Save")}}</vs-button>
        </vs-popup>

        <vs-popup style="z-index: 54000" :title="$t('Edit')" :active.sync="activeEditInvoicingPrompt">
            <vs-checkbox class="mt-3" v-model="editInvoicingEnabled" >{{$t("NonInvoicedPart")}}</vs-checkbox>
            <p class="mt-6">{{$t("NonInvoicedTime")}}</p>
            <vs-input v-model="editInvoicingTime"></vs-input>
            <p class="mt-6">{{$t("InvoicingComment")}}</p>
            <vs-textarea v-model="editInvoicingComment" class="w-full" />
            <vs-divider/>
            <vs-button :disabled="editInvoicingTime > editInvoicingMax" color="success" type="border" class="mt-6; mr-1" @click="saveInvoicing">{{$t("Save")}}</vs-button>
        </vs-popup>

        <vs-popup :title="$t('WorkType')" :active.sync="activeEditWorkTypePrompt" style="z-index: 54000">
            <div>
                <vs-select autocomplete class="selectExample" v-model="editWorkType">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in workTypeMap" />
                </vs-select>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="saveWorkType">{{$t("Save")}}</vs-button>
            </div>
        </vs-popup>

    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
            flatPickr
        },
        props: {
            taskId: {
                type: Number,
                required: true
            },
            users: {
                type: Object,
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            },
            projectHours: {
                type: Number,
                required: true
            },
            workTypes: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                activeNotesPrompt:false,
                activeNewTimePrompt: false,
                editSubTimePrompt: false,
                activeRemoveTimePrompt: false,
                activeMultiplierPrompt: false,
                activeEditInvoicingPrompt: false,
                activeEditWorkTypePrompt: false,
                startTimeEdit: null,
                endTimeEdit: null,
                taskStatus: null,
                selectedWorkTypeAdd: 0,
                selected: {},
                configDateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },
                selectedWorkType: 0,
                taskTimes: [],
                notesEditArea: '',
                notesEditAreaAdd: '',

                noteEditTimeId: '',

                subTimeEdit: {},
                removeSubTimeId: '',
                removeTimeReason: '',
                editTimeStartOpen: false,
                editTimeEndOpen: false,

                editMultiplierId: '',
                multiplier: '',
                multiplierEditReason: '',

                editInvoicingId: '',
                editInvoicingEnabled: '',
                editInvoicingTime: '',
                editInvoicingComment: '',
                editInvoicingMax: '',

                editWorkTypeId: 0,
                editWorkType: '',
            }
        },
        methods: {
            updateTimes() {
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/time")
                    .then(function (response) {
                        thisIns.taskTimes = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.$http.get('/api/v1/task/' + this.taskId + "/status")
                    .then(function (response) {
                        thisIns.taskStatus = response.data.status;

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            openNotesEditPrompt(id, text){
                this.noteEditTimeId = id;
                this.activeNotesPrompt = true;
                this.notesEditArea = text;
            },
            editSubTime() {
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/subtime/" + this.subTimeEdit['id'], {
                    start_time: thisIns.moment(thisIns.subTimeEdit["start_time"]).format(),
                    end_time: thisIns.moment(thisIns.subTimeEdit["end_time"]).format(),
                    reason: thisIns.subTimeEdit["reason"],
                }).then(function () {
                    thisIns.updateTimes();
                    thisIns.editSubTimePrompt = false
                }).catch(function (error) {
                    thisIns.editSubTimePrompt = false
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeTime() {
                const thisIns = this;
                this.$http.delete('/api/v1/task/' + this.taskId + "/subtime/" + thisIns.removeSubTimeId, {
                    data:{reason: this.removeTimeReason},
                })
                .then(function () {
                    thisIns.updateTimes();
                    thisIns.removeSubTimeId = 0;
                    thisIns.activeRemoveTimePrompt = false;
                }).catch(function (error) {
                    thisIns.activeRemoveTimePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editMultiplier(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/subtime/" + this.editMultiplierId + "/multiplier", {
                    multiplier: Number(thisIns.multiplier),
                    reason: thisIns.multiplierEditReason
                }).then(function () {
                    thisIns.updateTimes();
                    thisIns.activeMultiplierPrompt = false;
                }).catch(function (error) {
                    thisIns.activeMultiplierPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            saveNotes(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/time/" + this.noteEditTimeId + "/notes", {
                    notes: thisIns.notesEditArea
                }).then(function () {
                    thisIns.updateTimes();
                    thisIns.selected = {};
                    thisIns.activeNotesPrompt = false
                }).catch(function (error) {
                    thisIns.activeNotesPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            addTime() {
                const thisIns = this;
                this.$http.post('/api/v1/task/' + this.taskId + "/time", {
                    work_type_id: thisIns.selectedWorkTypeAdd,
                    notes: thisIns.notesEditAreaAdd
                }).then(function () {
                    thisIns.$http.get('/api/v1/task/' + thisIns.taskId + "/closed")
                        .then(function (response) {
                            thisIns.taskStatus = response.data.taskStatus;
                        })
                        .catch(function (error) {
                            thisIns.$vs.notify({
                                title:'Error',
                                text: error,
                                color:'danger',
                                iconPack: 'feather',
                                icon:'icon-alert-circle'})
                        });
                    thisIns.updateTimes();
                    thisIns.activeNewTimePrompt = false
                }).catch(function (error) {
                    thisIns.activeNewTimePrompt = false
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            saveInvoicing() {
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/time/" + this.editInvoicingId + "/invoicing", {
                    non_invoiced_part: thisIns.editInvoicingEnabled,
                    non_invoiced_time: Number(thisIns.editInvoicingTime),
                    non_invoiced_comment: thisIns.editInvoicingComment
                }).then(function () {
                    thisIns.updateTimes();
                    thisIns.selected = {};
                    thisIns.activeEditInvoicingPrompt = false
                }).catch(function (error) {
                    thisIns.activeEditInvoicingPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            saveWorkType() {
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/time/" + this.editWorkTypeId, {
                    work_type_id: thisIns.editWorkType,
                }).then(function () {
                    thisIns.updateTimes();
                    thisIns.editWorkTypeId = 0;
                    thisIns.activeEditWorkTypePrompt = false
                }).catch(function (error) {
                    thisIns.activeEditWorkTypePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            openTimeEditPrompt(id, start, end) {
                this.subTimeEdit['end_time'] = end;
                this.subTimeEdit['start_time'] = start;
                this.subTimeEdit['id'] = id;
                this.editSubTimePrompt = true
            },
            openTimeRemovePrompt(id) {
                this.removeSubTimeId = id;
                this.activeRemoveTimePrompt = true;
            },
            openMultiplierPrompt(id, multiplier) {
                this.editMultiplierId = id;
                this.multiplier = multiplier;
                this.multiplierEditReason = '';
                this.activeMultiplierPrompt = true;
            },
            openInvoicingEditPrompt(id, hasPart, time, comment, maxTime) {
                this.editInvoicingId = id;
                this.editInvoicingEnabled = hasPart;
                this.editInvoicingTime = Number(time);
                this.editInvoicingComment = comment;
                this.editInvoicingMax = Number(maxTime);
                this.activeEditInvoicingPrompt = true;
            },
            openEditWorkTypePrompt(id, type){
                this.editWorkType = Number(type);
                this.editWorkTypeId = id;
                this.activeEditWorkTypePrompt = true
            },
            changeEditTimeStartOpenStatus(status){
                const thisIns = this;
                setTimeout(function () {
                    thisIns.editTimeStartOpen = status
                }, 100 )

            },
            changeEditTimeEndOpenStatus(status){
                const thisIns = this;
                setTimeout(function () {
                    thisIns.editTimeEndOpen = status
                }, 100 )
            }

        },
        computed: {
            workTypeMap: function () {

                let types = {};
                for(let x = 0; x < this.workTypes.length; x++){
                    types[this.workTypes[x].id] = this.workTypes[x];
                }
                return types

            },
            projectHoursUsed: function () {
                let total = 0;
                for(let x = 0; x < this.taskTimes.length; x++){
                    total += Number(this.taskTimes[x].total_time);
                }

                return total
            }
        },
        watch:{
            taskId: function () {
                this.updateTimes();
            },
            editSubTimePrompt: function () {
                if(!this.editSubTimePrompt && (this.editTimeStartOpen || this.editTimeEndOpen)){
                    this.editSubTimePrompt = true;
                }
            }
        },
        created() {

            this.updateTimes();

        }

    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 140px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
